import axiosInstance from './config/api';
import type { QueueAlert } from 'types/queueAlert.type';

export type GetQueueAlertsParams = {
    /** Narrows to one workflow. The tenant always comes from the session, never from here. */
    workflowId?: string;
    /** Defaults to open alerts only on the backend; pass false to include resolved history. */
    active?: boolean;
};

export type QueueAlertListResponse = {
    alerts: QueueAlert[];
};

/** Manager-gated: an agent session gets a 403 rather than an empty list. */
export const getQueueAlerts = ({ workflowId, active }: GetQueueAlertsParams = {}) => {
    return axiosInstance
        .get<QueueAlertListResponse>('/queue-alerts', {
            params: {
                ...(workflowId ? { workflowId } : {}),
                ...(typeof active === 'boolean' ? { active } : {}),
            },
        })
        .then((res) => res.data);
};
